import { ButtonControl } from "@/Common/Components/Buttons/ButtonControl";
import { Modal } from "@/Common/Components/Modals/Modal";
import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { relativeStore } from "@/Relative/Stores/RelativeStore";

import styles from "./RelativeToPatientPopup.module.scss";

interface IRelativeToPatientPopupProps {
    onCancel: () => void;
}

function RelativeToPatientPopup(props: IRelativeToPatientPopupProps): JSX.Element {
    const { getText } = useTranslation();

    const relative = relativeStore.GetCurrent();

    const convertToPatient = (): void => {
        relativeStore.actions.convertToPatient(relative);
    };

    const footer: JSX.Element = (
        <div className="p-footer">
            <div className="row">
                <div className="col-sm-12 columns text-right">
                    <ButtonControl
                        className="btn btn-default push-right-5"
                        onClick={() => props.onCancel()}
                        label={getText("CancelLabel")}
                    />
                    <ButtonControl
                        className="btn btn-primary push-right-5"
                        onClick={() => convertToPatient()}
                        label={getText("RelativeFile_ConvertToPatientLabel")}
                    />
                </div>
            </div>
        </div>
    );

    return (
        <Modal
            title={getText("CreatePatientFileLabelTitle")}
            onClose={() => props.onCancel()}
            footer={footer}
            draggable
            centerContent
            showX
            width={500}
            showOverlay
        >
            <p className={styles.message}>{getText("RelativeFile_ConvertToPatientMessageLabel")}</p>
        </Modal>

    );
}

export { RelativeToPatientPopup };
